import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
        this.admissionType = document.querySelector('#admission-type');
        this.admissionStatut = document.querySelector('#admission-statut');
    }

    init() {

        eventAdd(this.admissionType, 'change', (e) => {
            this.updateAccordions();
        })
        eventAdd(this.admissionStatut, 'change', (e) => {
            this.updateAccordions();
        })
    }

    updateAccordions(){
        classRemove(document.querySelector('.c-admission-accordions.is-active'), 'is-active');
        classRemove(document.querySelector('.js-admission-preparation__wrap.is-active'), 'is-active');
        let thisAdmissionTypeText = this.admissionType.options[this.admissionType.selectedIndex].text;
        document.querySelector('.js-accordions-type-text').innerHTML = thisAdmissionTypeText;
        let thisAdmissionStatutText = this.admissionStatut.options[this.admissionStatut.selectedIndex].text;
        document.querySelector('.js-accordions-statut-text').innerHTML = thisAdmissionStatutText;
        if(this.admissionType.value >= 1 && this.admissionStatut.value >= 1){
            document.querySelector('.js-admission-accordions_'+this.admissionType.value+'_'+this.admissionStatut.value).classList.add('is-active');
            document.querySelector('.js-admission-preparation__wrap').classList.add('is-active');
        }
        
        if(document.querySelector('.js-accordions-type-une') != null){
            if(this.admissionType.value == 4){ // Ajoute "e" a une pour la maîtrise.
                document.querySelector('.js-accordions-type-une').setAttribute('style', '');
            }else{
                document.querySelector('.js-accordions-type-une').setAttribute('style', 'display: none;');
            }
        }
    }
    destroy(){
        eventRemove(this.admissionType, 'change', (e) => {
            this.updateAccordions();
        })
        eventRemove(this.admissionType, 'change', (e) => {
            this.updateAccordions();
        })
    }
}

/*
    USAGE :
    <div class="myElement" data-module="classToggle" data-target=".c-header" data-class="toggleThisClass" data-focus=".myInputClass"></div>

    data-class :     [text element "has-state-open"]     Is required and will toggle this class on data-target
    data-target : [scoped element ".myClass"]         Isn't required, if not it falls back to .barba-container
    data-focus :     [scoped element ".myClass"]         Isn't required, focus the element when clicked (Ex. search input)
 */